export const GET_SALES_ORDER = 'GET_SALES_ORDER';
export const GET_SALES_ORDER_ERROR = 'GET_SALES_ORDER_ERROR';
export const NO_MORE_SALES_ORDER = 'NO_MORE_SALES_ORDER';
export const GET_SALES_ORDER_SUCCESS = 'GET_SALES_ORDER_SUCCESS';
export const GET_SALES_ORDER_NOTIFICATIONS = 'GET_SALES_ORDER_NOTIFICATIONS';
export const GET_SALES_ORDER_NOTIFICATIONS_ERROR = 'GET_SALES_ORDER_NOTIFICATIONS_ERROR';
export const GET_SALES_ORDER_NOTIFICATIONS_SUCCESS = 'GET_SALES_ORDER_NOTIFICATIONS_SUCCESS';
export const RESEND_SALES_ORDER = 'RESEND_SALES_ORDER';
export const RESEND_SALES_ORDER_ERROR = 'RESEND_SALES_ORDER_ERROR';
export const RESEND_SALES_ORDER_SUCCESS = 'RESEND_SALES_ORDER_SUCCESS';
export const RESOLVE_SALES_ORDER = 'RESOLVE_SALES_ORDER';
export const RESOLVE_SALES_ORDER_ERROR = 'RESOLVE_SALES_ORDER_ERROR';
export const RESOLVE_SALES_ORDER_SUCCESS = 'RESOLVE_SALES_ORDER_SUCCESS';